/**
 * Auto-submit handler for forms with auto_submit data attribute
 * Replaces inline onchange="this.form.submit()" with proper event handling
 */

export function initAutoSubmit(): void {
  document.querySelectorAll("[data-auto_submit]").forEach((form) => {
    const select = form.querySelector("[data-auto_submit_target='select']");
    if (select instanceof HTMLSelectElement) {
      select.addEventListener("change", () => {
        if (form instanceof HTMLFormElement) {
          form.submit();
        }
      });
    }
  });
}

document.addEventListener("turbo:load", initAutoSubmit);
